import type { Exercice } from '@mairistem/comptabilite';
import { getErrorMessage } from '@mairistem/finances-utils';
import { toast } from 'react-toastify';
import BordereauEtat from '../../../constants/liquidation/bordereaux/BordereauEtat';
import Tdt from '../../../interfaces/common/Tdt';
import ActionResultType from '../../../interfaces/pieces/ActionResultType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type { BaseLiquidationOptions } from '../../../interfaces/pieces/mouvements/liquidation/BaseLiquidationOptions';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type TreeviewActionResult from '../../../interfaces/pieces/TreeviewActionResult';
import { updateBordereau } from '../../../services/piecesComptables/bordereaux/bordereaux';
import BaseLiquidationAction from '../../pieces/BaseLiquidationAction';

/**
 * La génération du flux est faite par la modale, qui affiche les erreurs.
 * executeAction met à jour le bordereau une fois le flux téléchargé.
 */
class BordereauEmettreLeFlux360Action extends BaseLiquidationAction<
	BordereauWithState,
	BordereauActionType
> {
	constructor(options?: BaseLiquidationOptions) {
		super(options);
		this.label = 'Émettre le flux 360';
		this.type = BordereauActionType.EMETTRE_LE_FLUX_360;
	}

	execute = (
		_bordereau: BordereauWithState,
	): TreeviewActionResult<BordereauWithState> => ({
		type: ActionResultType.MODAL,
		extraProps: {
			emettreFlux360Modal: {
				visible: true,
			},
		},
	});

	executeAction = (
		bordereau: BordereauWithState,
		exercice: Exercice,
	): TreeviewActionResult<BordereauWithState> => {
		const result = updateBordereau(
			{
				...bordereau,
				etat:
					exercice.entite.tdtIxchange2 === Tdt.IXCHANGE2
						? BordereauEtat.TRAITEMENT_PES_EN_INSTANCE
						: '',
				acquitte: 0,
				anomalieAck: '',
				motifEchec: '',
			},
			new URLSearchParams({ withJournaux: 'true' }),
		).catch((error) => {
			toast.error(
				getErrorMessage(error, 'Erreur lors de la modification du bordereau'),
			);
			throw error;
		});

		return {
			result,
			type: ActionResultType.UPDATE,
		};
	};
}

export default BordereauEmettreLeFlux360Action;
